// extracted by mini-css-extract-plugin
export default {"content":"styles_content__voy3R styles_content__1snT4","header":"styles_header__UN3YV styles_header__OIMvR","body":"styles_body__7nqsJ"};